import _ from 'lodash'

import VueDayJS from 'vue-dayjs'

import { createRouter } from './router'

import { getRoutes } from './routes-site'
import { getRoutes as getCommonRoutes, getWaits as getCommonWaits } from './routes-common'
import {
  getRoutes as getOrderRoutes,
  getWaits as geOrderWaits,
} from './routes-orders'
import {
  getAuthenticationWaits,
  getRoutes as getSecurityRoutes,
  getWaits as getSecurityWaits,
} from './routes-security'

import { getWaits as getProductSearchWaits } from './routes/product-search'

import { createStore } from './store'

import { createApp, VuePluginListItem } from './app'

import { getModules, getPersistModules } from './store/index-site'
import {
  getModules as getOrdersModules,
  getPersistModules as getOrdersPersistModules,
} from './store/index-orders'
import {
  getModules as getSecurityModules,
  getPersistModules as getSecurityPersistModules,
} from './store/index-security'

import VuexPersistence from 'vuex-persist'

import { getDirectives } from './directives'

const role = 'orders'

const securityModules = getSecurityModules()
const siteModules = getModules()
const ordersModules = getOrdersModules()

const modules = _.merge(
  {},
  securityModules,
  siteModules,
  ordersModules,
)

const persistModules = [
  ...getSecurityPersistModules(),
  ...getPersistModules(),
  ...getOrdersPersistModules(),
]

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: persistModules, // this is a list of vuex modules that should persist
})

const plugins: VuePluginListItem[] = [{ plugin: VueDayJS, options: {} }]

const storePlugins = [vuexLocal.plugin]

createStore({ modules, persistModules, role, plugins: storePlugins, isLoginAllowed: true, apiPrefix: '' }).then(
  (store) => {
    const waits = [
      ...getProductSearchWaits(store),
      ...getAuthenticationWaits(store),
      ...getSecurityWaits(store),
      ...getCommonWaits(store, true, true),
      ...geOrderWaits(store),
    ]
    const routes = [
      ...getCommonRoutes(),
      ...getSecurityRoutes(),
      ...getOrderRoutes(),
      ...getRoutes(),
    ]
    const directives = getDirectives(store)

    createRouter({ routes, waits }).then((router) => {
      createApp({ router, store, plugins, directives })
    })
  },
)
